import React, { Component } from 'react';
import LoadMask from 'Utils/LoadMask/LoadMask';
import Form from './TreatmentForm';

export default class TreatmentsCrear extends Component {

    state = {
        editar: false,
        mensaje: 'Agregar Tratamiento'
    }

    componentWillMount(){
        if(this.props.match.params.id){
            this.props.detail(this.props.match.params.id);
            this.setState({
                editar: true,
                mensaje: 'Editar Tratamiento'
            });
        }
    }

    render() {

        const {
            create,
            update,
        } = this.props;

        const {
            updateData,
            cargando,
        } = this.props;

        return (
            <div className="content">
                <div className="m-auto row-fluid big-card-form w-100">
                    <div className="table-decoration">
                        <LoadMask loading={cargando} blur_1>
                            {
                                this.state.editar ?
                                    <div>
                                        <div className="top-title">
                                            TRATAMIENTO
                                        </div>
                                        <Form
                                        onSubmit={update}
                                        updateData={updateData}
                                        editando={true} />
                                    </div>
                            :
                                <div>
                                    <div className="top-title">
                                        CREAR TRATAMIENTO
                                    </div>
                                    <Form onSubmit={create} />
                                </div>
                            }
                        </LoadMask>
                    </div>
                </div>
            </div>
        )
    }
}
